// src/pages/info-destacada/NuevaInfo.js
import React, { useState, useEffect } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import { FormLabel, Offcanvas } from 'react-bootstrap'
import { PanelFooter, PanelHeader } from 'components/Panel'

import IconSelector, { getIconClass } from 'components/IconSelector'
import ColorPicker from 'components/ColorPicker'

function NuevaInfo(props) {
	const { mostrar, guardar, cancelar } = props

	const datosIniciales = {
		icono: '',
		titulo: '',
		contenido: '',
		colorLetra: '#ffffff',
		activo: true
	}

	const [datosInfo, setDatosInfo] = useState(datosIniciales)
	const [erroresValidacion, setErroresValidacion] = useState({})
	const [loading, setLoading] = useState(false)

	useEffect(() => {
		if (!mostrar) {
			// Reset al cerrar
			setDatosInfo(datosIniciales)
			setErroresValidacion({})
		}
	}, [mostrar])

	const handleClose = () => {
		setDatosInfo(datosIniciales)
		setErroresValidacion({})
		cancelar()
	}

	const handleChange = (value, key) => {
		setDatosInfo(prev => ({
			...prev,
			[key]: value
		}))
	}

	const validarDatos = () => {
		const nuevosErrores = {}

		if (!datosInfo.icono) {
			nuevosErrores.icono = 'El ícono es requerido'
		}

		if (!datosInfo.titulo.trim()) {
			nuevosErrores.titulo = 'El título es requerido'
		}

		if (!datosInfo.contenido.trim()) {
			nuevosErrores.contenido = 'El contenido es requerido'
		}

		setErroresValidacion(nuevosErrores)
		return Object.keys(nuevosErrores).length === 0
	}

	const handleProcesar = async (e) => {
		e.preventDefault()

		if (validarDatos()) {
			setLoading(true)
			try {
				await guardar(datosInfo)
				handleClose()
			} catch (error) {
				console.error(error)
			} finally {
				setLoading(false)
			}
		}
	}

	// render
	return (
		<Offcanvas show={mostrar} onHide={handleClose} placement="end" style={{ width: '50%' }}>
			<PanelHeader onClick={handleClose} iconClass="fa-arrow-left" btnText="Atrás" text="Nueva información destacada" />
			<Offcanvas.Body id="nueva-info-destacada">
				<h5 className="mb-3">Campos de la información</h5>
				<Row>
					<Col sm={12}>
						<Form onSubmit={handleProcesar}>
							<Row>
								<Col>
									<Form.Group className="mb-3" controlId="info-activo">
										<Form.Check
											type="switch"
											label="Activa (visible en el sitio web)"
											checked={datosInfo.activo}
											onChange={(e) => handleChange(e.target.checked, 'activo')}
										/>
									</Form.Group>
								</Col>
							</Row>

							<Row>
								<Col md={6}>
									<Form.Group className="mb-3" controlId="info-icono">
										<FormLabel>Ícono *</FormLabel>
										<IconSelector
											value={datosInfo.icono}
											onChange={(value) => handleChange(value, 'icono')}
										/>
										{erroresValidacion.icono && (
											<div className="text-danger mt-1">
												<small>{erroresValidacion.icono}</small>
											</div>
										)}
									</Form.Group>
								</Col>
								<Col md={6}>
									<ColorPicker
										label="Color de letra"
										value={datosInfo.colorLetra}
										onChange={(color) => handleChange(color, 'colorLetra')}
									/>
								</Col>
							</Row>

							<Row>
								<Col>
									<Form.Group className="mb-3" controlId="info-titulo">
										<FormLabel>Título *</FormLabel>
										<Form.Control
											type="text"
											value={datosInfo.titulo}
											onChange={(e) => handleChange(e.target.value, 'titulo')}
											isInvalid={!!erroresValidacion.titulo}
											placeholder="Ej: ENVÍO <b>GRATIS</b>"
										/>
										<Form.Control.Feedback type="invalid">
											{erroresValidacion.titulo}
										</Form.Control.Feedback>
										<Form.Text className="text-muted">
											Soporta HTML básico: &lt;b&gt;, &lt;i&gt;, &lt;strong&gt;
										</Form.Text>
									</Form.Group>
								</Col>
							</Row>

							<Row>
								<Col>
									<Form.Group className="mb-3" controlId="info-contenido">
										<FormLabel>Contenido *</FormLabel>
										<Form.Control
											as="textarea"
											rows={3}
											value={datosInfo.contenido}
											onChange={(e) => handleChange(e.target.value, 'contenido')}
											isInvalid={!!erroresValidacion.contenido}
											placeholder="Descripción breve del beneficio..."
										/>
										<Form.Control.Feedback type="invalid">
											{erroresValidacion.contenido}
										</Form.Control.Feedback>
										<Form.Text className="text-muted">
											Soporta HTML básico: &lt;b&gt;, &lt;i&gt;, &lt;strong&gt;
										</Form.Text>
									</Form.Group>
								</Col>
							</Row>

							{/* Vista previa */}
							<Row className="mt-4">
								<Col>
									<FormLabel>Vista previa</FormLabel>
									<div className="info-preview p-3 rounded" style={{ backgroundColor: '#6c757d' }}>
										<div className="d-flex align-items-center gap-3">
											{datosInfo.icono && (
												<i
													className={`${getIconClass(datosInfo.icono)} fa-2x`}
													style={{ color: datosInfo.colorLetra }}
												></i>
											)}
											<div>
												<div
													style={{ color: datosInfo.colorLetra, fontWeight: 'bold' }}
													dangerouslySetInnerHTML={{ __html: datosInfo.titulo || 'Título' }}
												/>
												<div
													style={{ color: datosInfo.colorLetra, fontSize: '0.9em' }}
													dangerouslySetInnerHTML={{ __html: datosInfo.contenido || 'Contenido descriptivo' }}
												/>
											</div>
										</div>
									</div>
								</Col>
							</Row>
						</Form>
					</Col>
				</Row>
			</Offcanvas.Body>
			<PanelFooter>
				<Button variant="outline-secondary" onClick={handleClose} className="me-2" disabled={loading}>
					Cancelar
				</Button>
				<Button
					variant="primary"
					onClick={handleProcesar}
					disabled={loading}
				>
					{loading ? (
						<><i className="fa fa-spinner fa-spin me-2"></i> Guardando...</>
					) : (
						<><i className="fa fa-save me-2"></i> Guardar</>
					)}
				</Button>
			</PanelFooter>
		</Offcanvas>
	)
}

export default NuevaInfo
